export const breadcrumbMap: Record<string, string> = {
  "/": "Home",
  "/services": "Services",
  "/services/medicine": "General Medicine",
  "/services/dentalCare": "Dental Care",
  "/services/orthopedics": "Orthopedics",
  "/services/surgery": "Surgery",
};
